import safariIconAvifSrc from '../assets/browsers/safari.avif';
import safariIconWebpSrc from '../assets/browsers/safari.webp';
import safariIconSrc from '../assets/browsers/safari.png';
import chromeIconAvifSrc from '../assets/browsers/chrome.avif';
import chromeIconWebpSrc from '../assets/browsers/chrome.webp';
import chromeIconSrc from '../assets/browsers/chrome.png';
import browserIconAvifSrc from '../assets/browsers/browser.avif';
import browserIconWebpSrc from '../assets/browsers/browser.webp';
import browserIconSrc from '../assets/browsers/browser.png';

const getBrowserImage = () => {
  if (navigator.userAgent.includes('Chrome') || navigator.userAgent.includes('CriOS')) {
    return {
      sources: {
        avif: chromeIconAvifSrc,
        webp: chromeIconWebpSrc,
        png: chromeIconSrc
      },
      name: 'Chrome'
    };
  }

  if (navigator.userAgent.includes('Safari')) {
    return {
      sources: {
        avif: safariIconAvifSrc,
        webp: safariIconWebpSrc,
        png: safariIconSrc
      },
      name: 'Safari'
    };
  }

  return {
    sources: {
      avif: browserIconAvifSrc,
      webp: browserIconWebpSrc,
      png: browserIconSrc
    }
  };
};

export default getBrowserImage;
